import { z } from 'zod';
import { apiRequest } from '../masterdata/repository';

const accessSchema = z.object({
  permissions: z.array(z.string()),
  employee: z.object({
    status: z.enum(['linked', 'not_linked', 'inactive']),
    employee_id: z.string().nullable(),
  }),
});
export type Access = z.infer<typeof accessSchema>;
export async function getAccess(signal: AbortSignal): Promise<Access> {
  return accessSchema.parse(await apiRequest('/me/access', 'GET', undefined, signal));
}
